import { ACCORDIAN_INDEX, PAGE_LOADER } from "./actionTypes"

const initialState = {
  pageLoader: false,
  accordIndex: ''
}

const globalLists = (state = initialState, action) => {
  switch (action.type) {
    case PAGE_LOADER:
      state = { ...state, pageLoader: action.payload }
      break

    case ACCORDIAN_INDEX:
      state = { ...state, accordIndex: action.payload }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default globalLists
